export const menuItems = [
    {
        id: 1,
        label: "Dashboard",
        icon: "ri-dashboard-line",
        link: "/",
        permission: null, // 不需要權限，所有人都可以看到
    },
    {
        id: 2,
        label: "測驗模組",
        isTitle: true,
        permission: null, // 標題不需要權限，但需要檢查子項目
    },
    {
        id: 3,
        label: "文法小測驗",
        icon: "ri-dashboard-line",
        link: "/plugin/voices/list",
        permission: "add_game", // 需要「新增遊戲」權限
    },
    {
        id: 6,
        label: "答題紀錄",
        isTitle: true,
        permission: null, // 標題不需要權限，但需要檢查子項目
    },
    {
        id: 7,
        label: "用戶答題紀錄",
        icon: " ri-file-user-fill",
        link: '/users/records/user/list',
        permission: "view_records", // 需要「用戶使用紀錄總表查看」權限
    },
    {
        id: 8,
        label: "單元答題紀錄",
        icon: " ri-file-user-fill",
        link: '/users/records/unit/list',
        permission: "view_records", // 需要「用戶使用紀錄總表查看」權限
    },
    {
        id: 9,
        label: "系統管理",
        isTitle: true,
        permission: null, // 標題不需要權限，但需要檢查子項目
    },
    {
        id: 10,
        label: "帳號管理",
        icon: "ri-account-circle-fill",
        link: '/manager/list',
        permission: "manage_accounts", // 需要「後台帳號管理」權限
    },
];

